import {select} from 'd3-selection';
import {geoPath, geoMercator} from 'd3-geo';
import * as turf from '@turf/turf';


export const drawInset = (acres, coords) => {

  const drawCa = (data) => {
    let height = 60,
        width = height*.94;

    const svg = select('#ca-inset').append("svg")
                        .attr("width", width)
                        .attr("height", height)
                        .append('g')
                        .attr('class', 'map');

    const projection = geoMercator();

    const path = geoPath()
        .projection(projection.fitExtent([[0, 0], [width, height]], data));

    const g = svg.append("g")
        .attr("class", "states")
    g.selectAll("path")
        .data(data.features)
      .enter().append("path")
        .attr("d", path)
        .style("fill", "#E1E0D5")
        .style('stroke', '#999')
        .style('stroke-width', .5)
        .style("opacity", 1);

    const b = window.fireMap.getBounds();
    const topLat = b['_ne']['lat'],
          bottomLat = b['_sw']['lat'],
          leftLng = b['_sw']['lng'],
          rightLng = b['_ne']['lng'];

    const bB = [
      [leftLng, topLat],
      [rightLng, topLat],
      [rightLng, bottomLat],
      [leftLng, bottomLat],
      [leftLng, topLat]
    ];

    let boxIt = {
      "type":"Feature",
      "properties":{},
      "geometry":{
        "type":"Polygon",
        "coordinates":[bB]
      }
    };

    if(acres > 50000){
      svg.append("g")
          .attr("class", "box")
        .selectAll("path")
          .data([boxIt])
        .enter().append("path").classed('rect', true)
          .attr("d", path)
          .style("fill", "rgba(0,0,0,0)")
          .style('stroke', '#FF7F00')
          .style('stroke-width', 1)
          .style("opacity", 1);
    } else {
      // add point to svg
      svg.selectAll("circle")
        .data([coords]).enter()
        .append("circle")
        .attr("cx", function (d) { return projection(d)[0]; })
        .attr("cy", function (d) { return projection(d)[1]; })
        .attr("r", "2px")
        .attr("fill", "#FF7F00")
    }

    document.getElementById('detail-card').style.display = 'flex';

  }

  fetch("../assets/ca-inset.geojson")
    .then(r => r.json())
    .then(drawCa);
}
